import React from "react";
import { X, ChevronLeft } from "lucide-react";

const FormHeader = ({ title, subtitle, onClose, onBack }) => {
  return (
    <div className="relative px-12 py-16 bg-white dark:bg-[#080808] border-b border-stone-100 dark:border-white/5 flex items-center justify-between overflow-hidden">
      
      {/* Background Accent: Garis tipis aksen di sisi kiri untuk struktur visual */}
      <div className="absolute top-0 left-0 w-2 h-full bg-slate-900 dark:bg-white" />

      <div className="flex items-center gap-14">
        {/* Tombol Back: Desain Minimalis & Jelas dengan label "Return" */}
        {onBack && (
          <button 
            type="button"
            onClick={onBack}
            className="group flex flex-col items-center gap-3 transition-all active:scale-90"
            title="Go Back"
          >
            <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-stone-50 dark:bg-white/5 border border-stone-100 dark:border-white/10 group-hover:bg-slate-900 dark:group-hover:bg-white transition-all duration-300">
              <ChevronLeft size={24} strokeWidth={2.5} className="text-slate-900 dark:text-white group-hover:text-white dark:group-hover:text-slate-900 group-hover:-translate-x-1 transition-all" />
            </div>
            <span className="text-[10px] font-black uppercase tracking-[0.3em] text-stone-400 group-hover:text-slate-900 dark:group-hover:text-white">
              Return
            </span>
          </button>
        )}
        
        <div className="flex flex-col gap-3">
          {/* Judul: Tipografi Bold & Italic untuk kesan dinamis dan profesional */}
          <h3 className="text-5xl font-black text-slate-900 dark:text-white uppercase tracking-[-0.05em] leading-none italic">
            {title}
          </h3>
          
          {/* Subtitle: Menggunakan aksen warna biru untuk identitas teknologi */}
          <div className="flex items-center gap-4">
            <div className="w-8 h-[2px] bg-blue-600 rounded-full" />
            <p className="text-[11px] font-bold text-stone-400 dark:text-stone-500 uppercase tracking-[0.4em] leading-none antialiased">
              {subtitle}
            </p>
          </div>
        </div>
      </div>

      {/* Close Button: Desain Square minimalis dengan rotasi hover */}
      {onClose && (
        <button 
          type="button"
          onClick={onClose} 
          className="group w-16 h-16 flex items-center justify-center rounded-2xl hover:bg-red-50 dark:hover:bg-red-500/10 transition-all duration-300"
        >
          <X size={32} strokeWidth={1} className="text-stone-300 group-hover:text-red-500 group-hover:rotate-90 transition-all duration-500" />
        </button>
      )}
    </div>
  );
};

export default FormHeader;